<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-card-text>
                <v-row dense justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field dense v-model="ay" label="Academic Year" readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field dense v-model="standard" label="Standard" readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field dense v-model="division" label="Division" readonly filled outlined></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="2" md="2">
                        <v-text-field dense v-model="dayno" label="Day Number" readonly filled outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>

                        <v-row>
                            <v-col cols="12" sm="2" md="2">Student List</v-col>

                            <v-col cols="12" sm="2" md="2">
                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense v-model="atten_date" v-bind="attrs" v-on="on"
                                            hint="Date of Attendance" prepend-icon="event"
                                            persistent-hint></v-text-field>
                                    </template>
                                    <span v-if="ALLOW_POST_STUDENT_ATTENDANCE">
                                        <v-date-picker v-model="date" no-title @input="menu1 = false"
                                            @change="getAcademicPlanDetails()"></v-date-picker>
                                    </span>
                                    <span v-else> <v-date-picker v-model="date" no-title @input="menu1 = false"
                                            :max="nowDate" @change="getAcademicPlanDetails()"></v-date-picker></span>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="Enable_Whatsapp_Notification_For_Student_Attendance">
                           <center>    <v-checkbox v-model="send_whatsapp_msg_for_absent">
                                    <template #label>
                                        Send Absent Message To Parent Whatsapp
                                    </template>
                                </v-checkbox>
                                </center>
                            </v-col>
                               <v-col cols="12" sm="2" md="2" v-if="Enable_System_Notification_For_Student_Attendance">
                           <center>    <v-checkbox v-model="send_system_msg_for_absent">
                             <!-- Send Absent Meassage To Parent Portal & App -->
                                    <template #label>Send Absent Alert</template>
                                </v-checkbox>
                                </center>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                               <center> 
                                <span v-if="holiday_details == ''">
                                    <v-btn class="mt-2"
                                    color="primary" @click="saveattendance()"
                                        :loading="save_loader">Save
                                        Attendance
                                    </v-btn> 
                                </span>
                                <span v-else>
                                    <v-btn class="mt-2" v-if="ALLOW_HOLIDAY_STUDENT_ATTENDANCE"
                                    color="primary" @click="saveattendance()"
                                        :loading="save_loader">Save
                                        Attendance
                                    </v-btn> 
                                </span>
                               
                                </center>

                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="Array.isArray(academic_plan_details)  && academic_plan_details.length > 0">
                                <v-simple-table dense class="elevation-1" fixed-header>
                                    <thead>
                                        <tr>
                                            <th class="">Sr. No.</th>
                                            <th class="">Event Today</th>
                                        </tr>
                                    </thead>
                                    <tbody style="overflow-y: scroll;">
                                        <tr v-for="(s, index) in academic_plan_details" :key="s.s_id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ s.event }}</td>
                                        </tr>
                                     
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-col>
                        </v-row>










                    </v-card-title>
                    <v-data-table v-model="selectedTasks" :single-select="singleSelect" :headers="headers"
                        :items="studentinfo" item-key="ldiv" :search="search" class="elevation-1" show-select
                        :items-per-page="-1">
                        <template v-slot:[`item.action`]="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        ALLOW_POST_STUDENT_ATTENDANCE: false,
        ALLOW_HOLIDAY_STUDENT_ATTENDANCE: false,
        academic_plan_details: [],
        holiday_details:[],
        save_loader: false,
        overlay: false,
        headers: [
            { text: "Roll Number", value: "rollnumber" },
            { text: "Student Name", value: "studentname" },
            { text: "Registration Number", value: "grnumber" },
            { text: "Total Present", value: "totalpresent" },
            { text: "Actions", value: "action", sortable: false },
        ],
        singleSelect: false,
        selectedTasks: [],
        divoff: "",
        studentinfo: "",
        ay: "",
        standard: "",
        division: "",
        dayno: "",
        search: "",
        atten_date: "",
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        editedIndex: {
            rollnumber: "",
            studentname: "",
            grnumber: "",
            totalpresent: "",
            ldiv: "",
        },
        nowDate: new Date().toISOString().slice(0, 10), ay_id: null,
        send_whatsapp_msg_for_absent: false,
        send_system_msg_for_absent:false,
        Enable_Whatsapp_Notification_For_Student_Attendance:false,
        Enable_System_Notification_For_Student_Attendance:false,
    }),

    mounted() {
        this.getDivisionStudent();
        this.atten_date = this.formatDate(this.date);
        this.ay_id = localStorage.getItem("academics_ay")
    },
    methods: {
        getAcademicPlanDetails() {
            const data = {
                date: this.date,
                divoff: this.$store.getters.divoff_id,
            };
            axios
                .post("/Academics/getAcademicPlans", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.academic_plan_details = res.data.events_details;
                        this.holiday_details = res.data.holiday_details;
                        this.ALLOW_HOLIDAY_STUDENT_ATTENDANCE = res.data.ALLOW_HOLIDAY_STUDENT_ATTENDANCE
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    //  this.onerror(error);
                })
                .finally(() => { });
        },
        getDivisionStudent() {
            // alert(localStorage.getItem('setstatus_id'))
            if (this.$store.getters.divoff_id == null) {
                // alert("divoff");
                this.$router.push({ name: "student-attendance" });
            }
            //this.divoff=this.$store.getters.divoff_id
            const data = {
                divoff: this.$store.getters.divoff_id,
                status: localStorage.getItem('setstatus_id'),
            };

            axios
                .post("/Academics/getDivisionStudent", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.studentinfo = res.data.studentinfo;
                        this.ay = res.data.ay;
                        this.standard = res.data.standard;
                        this.division = res.data.division;
                        this.dayno = res.data.dayno;
                        this.getAcademicPlanDetails();
                        this.ALLOW_POST_STUDENT_ATTENDANCE = res.data.ALLOW_POST_STUDENT_ATTENDANCE
                        this.ALLOW_HOLIDAY_STUDENT_ATTENDANCE = res.data.ALLOW_HOLIDAY_STUDENT_ATTENDANCE
                        this.Enable_Whatsapp_Notification_For_Student_Attendance = res.data.Enable_Whatsapp_Notification_For_Student_Attendance
                        this.Enable_System_Notification_For_Student_Attendance = res.data.Enable_System_Notification_For_Student_Attendance
                        //this.load=true
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        editItem(item) {
            this.editedIndex = this.studentinfo.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.$store.commit("setldiv_id", this.editedItem.ldiv);
            this.$router.push({ name: "view-studentattendance" });

            //this.dialog = true;
        },
        saveattendance() {
            //alert("presentstudents"+this.selectedTasks[0].ldiv)
            if (this.atten_date == "" || this.atten_date == null) {
                this.showSnackbar("#b71c1c", "Please Select Attendance Date");
                return;
            }
            const data = {
                presentstudent: [],
                date: this.atten_date,
                allstudents: [],
                divoff: this.$store.getters.divoff_id,
                dayno: this.dayno,
                status: localStorage.getItem('setstatus_id'),
                ay: this.ay_id,
                send_whatsapp_msg_for_absent: this.send_whatsapp_msg_for_absent,
                send_system_msg_for_absent: this.send_system_msg_for_absent
            };
            var index = 0;
            this.selectedTasks.forEach(function (item) {
                // your logic
                //alert("presentstudents"+item.studentname)
                data.presentstudent[index] = item.ldiv;
                index++;
            });
            index = 0;
            this.studentinfo.forEach(function (item) {
                // your logic
                //alert("presentstudents"+item.studentname)
                data.allstudents[index] = item.ldiv;
                index++;
            });
            this.save_loader = true;
            this.overlay = true;
            axios
                .post("/Academics/markAttendance", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.studentinfo = res.data.studentinfo;
                        //alert("Attendance Marked Successfully")
                        this.showSnackbar("#4caf50", "Attendance Marked Successfully..."); //res.data.status;
                        this.dayno = res.data.dayno;
                        this.save_loader = false;
                        this.overlay = false;
                        //this.load=true
                    } else {
                        this.showSnackbar("red", res.data.msg);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    watch: {
        date(val) {
            this.atten_date = this.formatDate(this.date);
        },
    },
};
</script>
